<template>
    <f7Page no-navbar>
        <!--<f7Navbar title="点读包">
            <f7-nav-right>
                <f7-link icon-ios="f7:search_strong" icon-md="material:search" href="/package/search"></f7-link>
            </f7-nav-right>
        </f7Navbar>-->
        <!-- <input type="text" readonly>-->
        <f7-subnavbar :inner="false">
            <f7-searchbar
                    placeholder="搜索点读包资源"
                    disable-button-text=""
                    customSearch
                    no-shadow
                    no-hairline
                    :backdrop="false"
                    @click.native="jumpToSearch"
            ></f7-searchbar>
        </f7-subnavbar>
        <div class="topTab">
            <div class="top_nav_module">
                <div class="top_nav_wrap">
                    <f7-swiper :init="false" class="top_nav_menu">
                        <!--<f7-swiper-slide class="sw">
                            <span >所有分类</span>
                        </f7-swiper-slide>-->
                        <f7-swiper-slide class="sw" :class="{active:index===activeTypeId}"
                                         v-for="(item,index) in resTypeList"
                                         :key="index">
                            <span @click="changeType(item,index)">{{item.typeName}}</span>
                        </f7-swiper-slide>
                    </f7-swiper>
                </div>
            </div>
        </div>
        <f7-tabs animated>
            <f7-tab v-for="(item,index) in resTypeList" :key="index" class="page-content package-wrap"
                    style='padding-top: 0'
                    :class="'tab-'+index">
                <section class='goods-items-wrap'>
                    <pack-item :pack="pack" v-for="(pack,index) in packs[item.typeId]"
                               :packType="item.itype"
                               @click.native="goDetail(pack)"
                               @downLoadPack="downLoadPack"
                               :key="index"></pack-item>
                </section>
                <infinite-loading @infinite="loadData(item,index,arguments)" spinner="bubbles">
                    <div slot="no-more">没有更多数据</div>
                    <div slot="no-results">没有数据</div>
                </infinite-loading>
            </f7-tab>
        </f7-tabs>
        <base-toolbar slot="fixed"></base-toolbar>
    </f7Page>
</template>

<script type="text/ecmascript-6">
  import {
    f7Block,
    f7List,
    f7ListItem,
    f7Button,
    f7Toolbar,
    f7Link,
    f7NavRight,
    f7Icon,
    f7Badge,
    f7Gauge,
    f7Swiper,
    f7SwiperSlide,
    f7Tab,
    f7Tabs,
    f7Subnavbar,
    f7Searchbar
  } from 'framework7-vue'
  import { globalConst as native, LOAD_COMPLATE, LOAD_ING, LOAD_NO, pageSize, modalTitle } from '../../lib/const'
  import { mapState } from 'vuex'
  import PackItem from 'section/packItem/PackItem'
  import infiniteLoading from 'vue-infinite-loading'
  import downLoadMixin from 'mixins/downLoadMixin'

  export default {
    mixins: [downLoadMixin],
    data () {
      return {
        progress: 50,
        resTypeList: [],
        activeTypeId: 0,
        packs: {},
        pageIndexList: [],
      }
    },
    async created () {
      const {commit} = this.$store
      commit('setActiveTabbarItem', 'package')
      await this.$store.dispatch({
        type: native.resTypeList
      }).then(({data}) => {
        this.resTypeList = [{'typeId': -1, 'type': '', 'typeName': '所有分类', 'typeDesc': ''}].concat(data)
        this.pageIndexList = this.resTypeList.map((row) => {
          this.$set(this.packs, row.typeId, [])
          return 0
        })
        this.$nextTick(() => {
          let mySwiper = this.$f7.swiper.create('.top_nav_menu', {
            pagination: '.swiper-pagination4',
            slidesPerView: 4.5,
            paginationClickable: true,
            spaceBetween: 5,
            freeMode: true,
          })
          /* let index = this.typeList.findIndex((item) => item.id === this.zoneId)
          mySwiper.slideTo(index)*/
        })
      })
    },
    mounted () {
    },
    methods: {
      jumpToSearch () {
        this.$f7router.navigate('/package/search')
      },
      goDetail (pack) {
        this.$f7router.navigate(`/package/detail/${pack.id}`)
      },
      loadData (item, index, args) {
        const typeId = item.typeId
        const $state = args[0]
        let {dispatch} = this.$store
        if (typeId === -1) {
          dispatch({
            type: native.resListAll,
            index: this.pageIndexList[index],
          }).then((data) => {
            let result = data.data
            if (Array.isArray(result) && result.length > 0) {
              result = result.map((row) => {
                row.downLoadText = '下载'
                return row
              })
              this.packs[typeId] = this.packs[typeId].concat(result)
              $state.loaded()
              this.pageIndexList[index] += 1
            } else {
              $state.complete()
            }
            if (result.length < pageSize) {
              $state.complete()
            }
          })
        } else {
          dispatch({
            type: native.resList,
            index: this.pageIndexList[index],
            typeId
          }).then((data) => {
            let result = data.data
            if (Array.isArray(result) && result.length > 0) {
              result = result.map((row) => {
                row.downLoadText = '下载'
                return row
              })
              this.packs[typeId] = this.packs[typeId].concat(result)
              $state.loaded()
              this.pageIndexList[index] += 1
            } else {
              $state.complete()
            }
            if (result.length < pageSize) {
              $state.complete()
            }
          })
        }
      },
      changeType (resType, index) {
        this.activeTypeId = index
        this.pageIndex = index
        this.$f7.tab.show(`.tab-${index}`)

      },
    },
    computed: {
      ...mapState({
        process: ({downLoader}) => downLoader.process,
        downLoaderServerUrl: ({downLoader}) => downLoader.downLoaderServerUrl
      })
    },
    destroyed () {
      console.log('package list destroyed')
    },
    components: {
      f7Block,
      f7List,
      f7ListItem,
      f7Button,
      f7Toolbar,
      f7Link,
      f7NavRight,
      f7Icon,
      f7Badge,
      f7Gauge,
      PackItem,
      f7Swiper,
      f7SwiperSlide,
      f7Tab,
      f7Tabs,
      infiniteLoading,
      f7Subnavbar,
      f7Searchbar
    }
  }
</script>
<style lang="scss" scoped type="text/css">
    @import "../../css/package.scss";
</style>
